import { useState } from 'react';
import PanelHeader from '../Panel/PanelHeader';

import classes from './AdminPanel.module.scss';
import PanelUserBody from '../Panel/PanelUserBody';
import Notifications from '../Notifications/Notifications';

export default function AdminPanel() {
  const [showUsers, setShowUsers] = useState(true);

  const setUserVisible = () => {
    setShowUsers(true);
  };

  const setNotificationsVisible = () => {
    setShowUsers(false);
  };

  return (
    <main className={classes.main}>
      <PanelHeader
        userShoewn={showUsers}
        userCliclHandler={setUserVisible}
        setNotificationsHandler={setNotificationsVisible}
      />
      <div className={classes.panel}>
        {showUsers && <PanelUserBody />}
        {!showUsers && <Notifications />}
      </div>
    </main>
  );
}
